import { customRegex } from './custom-regex.validators';
const caracteresAccesD = /^[A-Za-zÀÂÄÉÈÊËÌÎÏÒÔÖÙÛÜÇàâäéèêëìîïòôöùûüç0-9_#,.';$()\\\-+=«» ]+$/u;
const numeroUnite = /^[A-Za-z0-9]+$/;
const separationAvecUnEspace = /^\S+ .+$/;
const pasJusteDuTexteVide = /^(?!\s*$).+$/;
const numeroTelephone = /^([2-9])(?!\1{2}[ -]?\1{3}[ -]?\1{4})\d{2}[ -]?[2-9]\d{2}[ -]?\d{4}$/;
const courrielValide =
  /^([a-zA-Z0-9!#$%&'*+\-/=?_`{}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?_`{}~]+)*)@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.([A-Za-z]{0,61}[A-Za-z]\.)*([A-Za-z]{2,6}))+$/;
export class CustomValidators {
  public static readonly caracteresAccesDValide = customRegex(caracteresAccesD, {
    errorName: 'authorizedCharacters',
  });
  public static readonly doitAvoirUneSeparation = customRegex(separationAvecUnEspace, {
    errorName: 'separation',
    pretraitement: (value: string) => `${value}`.trimStart(),
  });
  public static readonly appartement = customRegex(numeroUnite, {
    errorName: 'appartement',
  });
  public static readonly texteNonBlanc = customRegex(pasJusteDuTexteVide, {
    errorName: 'textevide',
  });
  public static readonly telephoneNombreNonRepete = customRegex(numeroTelephone, {
    errorName: 'telephoneNombreNonRepete',
  });
  public static readonly courrielValide = customRegex(courrielValide, {
    errorName: 'courrielInvalide',
  });
}
